import i18next from 'i18next';
//Import all translation files
import English from './locales/en';
import Dutch from './locales/nl';
import { initReactI18next } from 'react-i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: English
  },
  nl: {
    translation: Dutch
  }
};

const options = {
  order: ['path', 'querystring', 'navigator'],
  lookupFromPathIndex: 0,
  lookupQuerystring: 'locale'
};

i18next
  .use(initReactI18next)
  .use(I18nextBrowserLanguageDetector)
  .init({
    supportedLngs: ['en', 'nl'],
    resources,
    detection: options
  });

export default i18next;
